import { describe, expect,it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  COMPANY_FIELDS,
  PAYER_ADDRESS_FIELDS,
  SHIP_TO_ADDRESS_FIELDS,
  SOLD_TO_ADDRESS_FIELDS} from '../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../utils/constants';
import { templateMap } from './create';

// ----------------- Type Definitions -----------------
interface Field {
  key: string;
  required?: boolean;
  conditionalCountryArray?: string[];
}

interface Card {
  key: string;
  fields?: Field[];
  fieldWrapper?: string;
}

interface Page {
  route: string;
  cards?: Card[];
}

// ----------------- Customer Setup Tests -----------------
describe('Customer Setup Templates', () => {
  const pages: Page[] = templateMap.customer_set_up.pages;

  it('exports 4 pages', () => {
    expect(pages).toHaveLength(4);
  });

  // ------------------ Company Page ------------------
  describe('Company Page', () => {
    const companyPage = pages.find(p => p.route === PAGE_ROUTES.company) as Page;

    it('has correct cards', () => {
      expect(companyPage.cards?.map(c => c.key)).toEqual([
        CARD_CATEGORIES.company,
        CARD_CATEGORIES.soldTo,
        CARD_CATEGORIES.billTo
      ]);
    });

    it('company card has required tradeDbaName', () => {
      const companyCard = companyPage.cards?.find(c => c.key === CARD_CATEGORIES.company) as Card;
      const tradeField = companyCard.fields?.find(f => f.key === COMPANY_FIELDS.tradeDbaName);
      expect(tradeField?.required).toBe(true);
    });

    it('soldTo card has conditionalCountryArray on taxNumber1', () => {
      const soldToCard = companyPage.cards?.find(c => c.key === CARD_CATEGORIES.soldTo) as Card;
      const field = soldToCard.fields?.find(f => f.key === SOLD_TO_ADDRESS_FIELDS.taxNumber1);
      expect(Array.isArray(field?.conditionalCountryArray)).toBe(true);
      expect(field?.conditionalCountryArray).toContain('TR'); // Example country
    });
  });

  // ------------------ ShipTo Page ------------------
  describe('ShipTo Page', () => {
    const shipToPage = pages.find(p => p.route === PAGE_ROUTES.shipTo) as Page;

    it('has address card with correct fields', () => {
      const addressCard = shipToPage.cards?.find(c => c.key === CARD_CATEGORIES.address) as Card;
      expect(addressCard.fields?.map(f => f.key)).toEqual([
        SHIP_TO_ADDRESS_FIELDS.address,
        SHIP_TO_ADDRESS_FIELDS.taxNumber1,
        SHIP_TO_ADDRESS_FIELDS.taxNumber2,
        SHIP_TO_ADDRESS_FIELDS.email
      ]);
    });

    it('has correct fieldWrapper', () => {
      const addressCard = shipToPage.cards?.find(c => c.key === CARD_CATEGORIES.address) as Card;
      expect(addressCard.fieldWrapper).toBe(CARD_CATEGORIES.shipTo);
    });
  });

  // ------------------ Financial Page ------------------
  describe('Financial Page', () => {
    const financialPage = pages.find(p => p.route === PAGE_ROUTES.financial) as Page;

    it('payer card has conditionalCountryArray on taxNumber1', () => {
      const payerCard = financialPage.cards?.find(c => c.key === CARD_CATEGORIES.payer) as Card;
      const field = payerCard.fields?.find(f => f.key === PAYER_ADDRESS_FIELDS.taxNumber1);
      expect(Array.isArray(field?.conditionalCountryArray)).toBe(true);
      expect(field?.conditionalCountryArray).toContain('TR');
    });

    it('financialAttachmentCard has correct field', () => {
      const attachmentCard = financialPage.cards?.find(c => c.key === CARD_CATEGORIES.financialAttachmentCard) as Card;
      expect(attachmentCard.fields?.[0].key).toBe(ATTACHMENT_FIELDS.financialCardAttachment);
    });

    it('additionalAttachmentCard has correct field', () => {
      const additionalCard = financialPage.cards?.find(c => c.key === CARD_CATEGORIES.additionalAttachmentCard) as Card;
      expect(additionalCard.fields?.[0].key).toBe(ATTACHMENT_FIELDS.additionalAttachment);
    });

    it('privacyPolicy card has no fields', () => {
      const privacyCard = financialPage.cards?.find(c => c.key === CARD_CATEGORIES.privacyPolicy) as Card;
      expect(privacyCard.fields).toBeUndefined();
    });
  });
});